import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Register from './Register';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/c/:slug/:token" element={<Register />} />
        <Route path="*" element={<p style={{ fontFamily: 'system-ui', padding: '2rem' }}>Not found.</p>} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
